Geef een diploma aan geselecteerde leden.
<mat-form-field>
  <mat-select placeholder="Placeholder" [formControl]="certificateForm">
    @for (cert of possibleCerts; track cert) {
      <mat-option [value]="cert.certificateID">
        {{ cert.name }}
      </mat-option>
    }
  </mat-select>
</mat-form-field>

<mat-dialog-actions align="end">
  <button mat-button (click)="onDismiss()">Annuleer</button>
  @if (certificateForm.valid) {
    <button
      mat-raised-button
      color="primary"
      (click)="onCommit()"
      [attr.disabled]="committing"
      >
      Bevestig
    </button>
  }
</mat-dialog-actions>
